"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBolderStatusIcon = void 0;
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../helpers");
const ErrorBolderStatusIcon = (props) => (react_1.default.createElement("svg", Object.assign({ viewBox: "0 0 16 16" }, (0, helpers_1.clearProps)(props), { width: "16", height: "16" }),
    react_1.default.createElement("path", { fill: "#e8595a", d: "M8 0a8 8 0 108 8 8 8 0 00-8-8zm4.55 10.72l-1.83 1.83L8 9.83l-2.72 2.72-1.83-1.83L6.17 8 3.45 5.28l1.83-1.83L8 6.17l2.72-2.72 1.83 1.83L9.83 8z" })));
exports.ErrorBolderStatusIcon = ErrorBolderStatusIcon;
//# sourceMappingURL=ErrorBolderStatusIcon.js.map